import { isDevMode } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'
import { LoggerFactory, LogLevel } from '@elderbyte/ts-logger'
import { appConfig } from './app/app.config'
import { AppComponent } from './app/main/app.component'

LoggerFactory.getDefaultConfiguration().withMaxLevel(isDevMode() ? LogLevel.Debug : LogLevel.Info)

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  LoggerFactory.getLogger('main').error('Error starting application', err)
})
